var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcpZero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MCP Zero Architecture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 120,
    fill: "#E8F4F8",
    stroke: "#0066CC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 300,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#0066CC",
    textAnchor: "middle"
  }, "Offline-First Core"), /*#__PURE__*/React.createElement("g", {
    id: "agreements"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 180,
    r: 60,
    fill: "#F0F9E8",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 180,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "Agreements")), /*#__PURE__*/React.createElement("g", {
    id: "memory-system"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 180,
    r: 60,
    fill: "#FFF3E0",
    stroke: "#FF9800",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 180,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#FF9800",
    textAnchor: "middle"
  }, "Memory System")), /*#__PURE__*/React.createElement("g", {
    id: "editor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 420,
    r: 60,
    fill: "#E8EAF6",
    stroke: "#3F51B5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 420,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#3F51B5",
    textAnchor: "middle"
  }, "Editor")), /*#__PURE__*/React.createElement("g", {
    id: "agent-system"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 420,
    r: 60,
    fill: "#FCE4EC",
    stroke: "#E91E63",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 420,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#E91E63",
    textAnchor: "middle"
  }, "Agent System")), /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 210,
    x2: 400,
    y2: 270,
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 210,
    x2: 400,
    y2: 270,
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 390,
    x2: 400,
    y2: 330,
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 390,
    x2: 400,
    y2: 330,
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 400,
    height: 40,
    rx: 20,
    fill: "#FFEBEE",
    stroke: "#F44336",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 125,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#F44336",
    textAnchor: "middle"
  }, "Ethical Governance Layer"), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 460,
    width: 400,
    height: 40,
    rx: 20,
    fill: "#E0F2F1",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 485,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#009688",
    textAnchor: "middle"
  }, "Cryptographic Integrity Layer"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpZero);
export default __webpack_public_path__ + "static/media/mcp-zero.78051ebb595dcb7db223528141b8717e.svg";
export { ForwardRef as ReactComponent };